import { render, staticRenderFns } from "./AvailableCategoriesFilter.vue?vue&type=template&id=1068246e&"
import script from "./AvailableCategoriesFilter.vue?vue&type=script&lang=js&"
export * from "./AvailableCategoriesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports